import { AxiosResponse } from 'axios';
import { measureData } from '../apis';
import { Pattern } from '../types/patternChart.types';

export const getPatternMeasureDatum = (
  tenant: string,
  patternId: string
): Promise<AxiosResponse<Pattern>> =>
  measureData.get<Pattern>(`${tenant}/PATTERN/${patternId}/RAW/data.json`);
